import React, { useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { classNames } from "../../../helpers/classNames";
import { useDebounce } from "../../../hooks/useDebounce";
import Search from "../../../components/form/Search";
import LimitSelect from "../../../components/elements/LimitSelect";
import Button from "../../../components/form/Button";
import { handleFilterChange } from "../../../helpers";
import { toast } from "react-toastify";
import Table from "../../../components/elements/table/Table";
import dayjs from "dayjs";
import Badge from "../../../components/elements/Badge";
import DeleteModal from "../../../components/common/DeleteModal";
import useMutation from "../../../hooks/useMutation";

import StatusSelect from "../../../components/elements/StatusSelect";
import {
  emailTemplateDelete,
  emailTemplateList,
  emailTemplateOrdering,
  emailTemplateStatusChange,
} from "../../../services/emailService";
import ManageEmailTemplateModal from "./modal/ManageEmailTemplateModal";
import Switch from "../../../components/form/Switch";

function EmailTemplate({ isDashBoard = false }) {
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: [filters, search],
    fetchFunction: async () => {
      const { roleCode = [], status = [], ...restFilters } = filters || {};

      const queryParams = {
        ...restFilters,
        ...(search && { keyword: search }),

        // ...Object.fromEntries([...roleCode].map((val, i) => [`roleCode[${i}]`, val])),
        ...Object.fromEntries(
          [...status].map((val, i) => [`status[${i}]`, val])
        ),
      };

      const res = await emailTemplateList(queryParams);
      console.log(res?.docs, " res?.docs);");

      return res?.docs || [];
    },
  });
  const tableHeadData = [
    {
      _id: 1,
      name: "Code",
      align: "left",
    },
    {
      _id: 2,
      name: "Subject",
      align: "left",
    },
    // {
    //   _id: 3,
    //   name: "Content",
    //   align: "left",
    // },
    {
      _id: 4,
      name: "To Mail",
      align: "left",
    },
    {
      _id: "fromName",
      name: "From Name",
      align: "left",
    },
    {
      _id: "status",
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            status: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.status;
            return { ...pre };
          });
        }
      },
      filterData: [
        { name: "Active", value: 1, type: "checkbox" },
        { name: "Inactive", value: 2, type: "checkbox" },
      ],
    },
    {
      _id: 5,
      name: "Action",
      align: "left",
    },
  ];

  const tableData = data?.data?.map((item) => {
    // console.log("itemdata", data?.data[0].image);
    console.log("item", item._id);
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.code || "-",
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.subject || "-",
        },
        // {
        //   _id: 3,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: item?.content || "-",
        // },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.toMail || "-",
        },
        {
          _id: "fromName",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.fromName || "-",
        },
        {
          _id: 111,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex gap-2 items-center">
              <Switch
                className={
                  "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                }
                checked={item?.status === 1}
                onChange={() => {
                  updateData((pre) => {
                    pre.data = (pre?.data || []).map((elm) =>
                      elm?._id === item?._id
                        ? { ...elm, status: elm?.status === 1 ? 2 : 1 }
                        : elm
                    );
                    return { ...pre };
                  });
                  emailTemplateStatusChange({
                    ids: item?._id,
                    status: item?.status === 1 ? 2 : 1,
                  });
                }}
              />
              <Badge
                type={item?.status === 1 ? "success" : "danger"}
                label={item?.status === 1 ? "Active" : "Inactive"}
              />
            </div>
          ),
        },
        {
          _id: 5,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                setModalOpen({ isOpen: true, data: item });
              },
              standout: false,
            },
            {
              _id: 3,
              // name: "Delete",
              // icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  function EmailManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
          refetch();
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?._id === res?.data?._id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message);
    }
  }

  //   user delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      // console.log("payload", payload);
      const res = await emailTemplateDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?.id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      }
    },
    onError: (error) => {
      toast.error(error || "Failed to delete email template");
    },
  });
  async function EmailTemplateOrderingHandler(newData, oldData) {
    console.log({ newData, oldData });

    const ordering_data = newData?.map((item, i) => ({
      id: item?._id,
      ordering: i + 1,
    }));
    const res = await emailTemplateOrdering({ ordering_data });
    if (res?.status !== 200) {
      updateData((pre) => {
        pre.data = oldData;
        return { ...pre };
      });
    }
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      {!isDashBoard && (
        <div className="space-y-8">
          <div className="font-bold text-center text-lg xl:text-3xl text-hobby text-chestnut-rose">
            Email Templates
          </div>
          <div className="flex items-center gap-3">
            <div className="w-36">
              <LimitSelect
                value={filters?.limit}
                allValue={data?.metadata?.totalDocs}
                onChange={(val) => handleFilterChange("limit", val, setFilters)}
              />
            </div>
            {/* <div className="w-36">
              <StatusSelect
                value={filters?.status}
                onChange={(val) =>
                  handleFilterChange("status", val, setFilters)
                }
              />
            </div> */}
            <div className="w-72">
              <Search
                placeholder={"Search here"}
                search={(val) => {
                  setKeyword(val);
                  handleFilterChange("page", 1, setFilters);
                }}
              />
            </div>
            {/* <div className="relative">
              <Button
                buttonClasses={
                  "!bg-transparent border border-transparent !h-10 hover:!bg-hobby/10 hover:!border-hobby/10"
                }
                buttonLabel={"Create New"}
                buttonLabelClasses={"font-medium !text-sm text-hobby"}
                buttonFunction={() =>
                  setModalOpen({ isOpen: true, data: null })
                }
              />
            </div> */}
          </div>
        </div>
      )}

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          //   setSelectedItems([]);
        }}
        handleOrdering={(newData, oldData) => {
          EmailTemplateOrderingHandler(newData, oldData);
        }}
        originalData={[...(data?.data || [])]}
        setOriginalData={(data) =>
          updateData((pre) => {
            pre.data = data;
            return { ...pre };
          })
        }
        // isFetching={isFetching}
        isOrderingDisabled={true}
        // selectedItems={selectedItems}
        // setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      {console.log(modalOpen, "modelopen")}
      <ManageEmailTemplateModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={EmailManageResponse}
      />
      {/* {console.log({ data: deleteModal?.data })} */}
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
}

export default EmailTemplate;
